export default "__VITE_ASSET__9455ded4__"